import styled from "styled-components";
import { Row } from 'antd';

export const RowAnt = styled(Row)`
    background-color: #fff;
    margin-bottom: 20px;
    width: 100%;
`;